import React from 'react';
import ExpandAbleTable from '../Home/Layout2/ExpandAbleTable';

function Agencies(props) {
  return <ExpandAbleTable />;
}

export default Agencies;
